import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function Hero() {
  const { t } = useTranslation();
  const { site } = useSiteSettings();

  return (
    <section className="relative w-full">
      <div
        className="relative w-full h-[420px] md:h-[600px] bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Dark%20moody%20automotive%20workshop%20with%20a%20car%20engine%20on%20a%20hoist%2C%20dramatic%20lit%20scene%2C%20charcoal%20black%20tones%20with%20warm%20golden%20accent%20lighting%2C%20professional%20auto%20spare%20parts%20workshop%2C%20masculine%20industrial%20atmosphere&width=1600&height=900&seq=apex-hero&orientation=landscape')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
        <div className="relative z-10 flex h-full w-full items-center justify-center">
          <div className="w-full px-4 md:px-6 text-center">
            <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-medium uppercase tracking-widest text-brand-gold backdrop-blur">
              <i className="ri-award-line"></i>
              {t("hero.badge")}
            </span>
            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-semibold uppercase leading-tight text-white">
              {t("hero.title1")} <span className="text-brand-gold">{t("hero.titleHighlight")}</span>
            </h1>
            <p className="mx-auto mt-4 max-w-2xl text-sm md:text-base text-white/80 leading-relaxed">
              {t("hero.desc", { siteName: site.site_name })}
            </p>
            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/contact-us"
                className="flex items-center gap-2 rounded-md bg-brand-gold px-7 py-3 text-sm font-semibold uppercase tracking-wide text-brand-dark transition hover:bg-white whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                {t("hero.contact")}
              </Link>
              <Link
                to="/engines"
                className="flex items-center gap-2 rounded-md border border-white/40 px-7 py-3 text-sm font-semibold uppercase tracking-wide text-white transition hover:border-brand-gold hover:text-brand-gold whitespace-nowrap"
              >
                {t("hero.browse")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}